export const DEFAULT_LEAF_IMAGE = require('@/assets/img-defaults/ww-leaf.jpg')
export const DEFAULT_WW_GRAY_LOGO = require('@/assets/img-defaults/ww-gray-logo.png')
export const BLANK_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
